export default __webpack_public_path__ + "static/media/checkGreen.3dbec259.svg";